import React from "react";
import {
  Box,
  CircularProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  Avatar,
  Chip,
  Typography,
  IconButton,
  Tooltip,
  Pagination,
} from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import VisibilityIcon from "@mui/icons-material/Visibility";

const ClassList = ({
  classesLoading,
  classes,
  page,
  totalPages,
  onPageChange,
  // getClassAssignmentCount,
  onViewAssignedExams,
}) => {
  return classesLoading ? (
    <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
      <CircularProgress />
    </Box>
  ) : classes.length === 0 ? (
    <Typography color="text.secondary" sx={{ textAlign: "center", p: 4 }}>
      No classes found
    </Typography>
  ) : (
    <Box>
      <List sx={{ width: "100%" }}>
        {classes.map((classItem, index) => (
          <React.Fragment key={classItem._id}>
            <ListItem
              sx={{
                borderRadius: 2,
                mb: 1,
                border: "1px solid rgba(0,0,0,0.08)",
                "&:hover": {
                  bgcolor: "#f5f5f5",
                },
              }}
            >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: "#2196F3" }}>
                  <SchoolIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography variant="subtitle1" fontWeight="600">
                    {classItem.className || classItem.name}
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      Class Code: {classItem.classCode}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {classItem.description}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Students: {classItem.studentCount || 0}
                    </Typography>
                    {/* <Chip
                      label={`${getClassAssignmentCount(
                        classItem._id
                      )} exams assigned`}
                      size="small"
                      sx={{ mt: 1, bgcolor: "#e8f5e8", color: "#2e7d32" }}
                    /> */}
                  </Box>
                }
              />
              <ListItemSecondaryAction>
                <Tooltip title="View assigned exams">
                  <IconButton 
                    edge="end"
                    onClick={() => onViewAssignedExams(classItem)}
                  >
                    <VisibilityIcon />
                  </IconButton>
                </Tooltip>
              </ListItemSecondaryAction>
            </ListItem>
          </React.Fragment>
        ))}
      </List>
      {totalPages > 1 && (
        <Pagination
          sx={{ mt: 2, display: "flex", justifyContent: "center" }}
          count={totalPages}
          page={page}
          onChange={(e, value) => onPageChange(value)}
          variant="outlined"
          color="primary"
        />
      )}
    </Box>
  );
};

export default ClassList;
